module.exports = __webpack_public_path__ + "static/media/chevron-orange.7725275e.svg";